/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/*
 * The file is automatically generated by Serenity UI.
 *
 * ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
 *
 * Found an issue? Submit a task to the ClickUp board:
 * https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
 */
import * as stylex from '@stylexjs/stylex';
import { GridColumns as ChartGridColumnsCore } from '@visx/grid';
import type { ComponentProps } from 'react';
import { type ForwardedRef, createContext, forwardRef } from 'react';
import { type ContextValue, useContextProps } from 'react-aria-components';
import { $ } from '../../tokens.stylex';

interface ChartGridColumnsProps
  extends Partial<
    Pick<
      ComponentProps<typeof ChartGridColumnsCore>,
      'scale' | 'height' | 'children' | 'from' | 'left' | 'numTicks' | 'offset' | 'tickValues' | 'to' | 'top'
    >
  > {
  style?: stylex.StyleXStyles;
}

const ChartGridColumnsContext = createContext<ContextValue<ChartGridColumnsProps, SVGLineElement>>({});

const ChartGridColumns = forwardRef((props: ChartGridColumnsProps, ref: ForwardedRef<SVGLineElement>) => {
  [props, ref] = useContextProps(props, ref, ChartGridColumnsContext);

  const { style, scale, height, ...coreProps } = props;

  return (
    <ChartGridColumnsCore
      innerRef={ref}
      scale={scale!}
      height={height!}
      stroke="inherit"
      {...stylex.props(styles.base, style)}
      {...coreProps}
    />
  );
});

const styles = stylex.create({
  base: {
    stroke: $.border06,
  },
});

export { ChartGridColumns, ChartGridColumnsContext, type ChartGridColumnsProps };
